import { parseSlateJSONToHTML } from 'components/TextEditor/utils'
import { useBorderListContext } from 'contexts/BorderListContext'
import { Form, PROFILE_STORAGE_KEY } from '../hooks/useForm'
import { useParams, useNavigate } from 'react-router-dom'
import { AlertContext } from 'contexts/AlertContext'
import { useAuth } from 'contexts/AuthContext'
import { useContext, useState } from 'react'
import { removeItem } from 'utils/storage'
import useStore from 'hooks/useStore'
import { POST } from 'api/request'
import * as urls from 'api/urls'

const useSending = (
  form: Form
) => {
  const [isSending, setSending] = useState<boolean>(false)
  const { isAuth } = useAuth()
  const params = useParams()

  const openStore = useStore()
  const navigate = useNavigate()
  const { reload } = useBorderListContext()
  const { showAlert } = useContext(AlertContext)

  const handleSubmit = async (showOrder = false, update = false) => {
    if (isSending) return
    setSending(true)
    const profileId = params['id'] || form.qrId
    const formData = generateFormData(!!profileId, form)

    try {
      if ((params['id'] && params['action'] === 'update') || update) {
        const response = await POST(urls.updatedBoard(profileId), {
          form: formData
        })
        if (response.ok) {
          const profileID = response.data?.data.id
          reload()
          showAlert('Zaktualizowano profil!', 'success')
          removeItem(true, PROFILE_STORAGE_KEY)
          navigate(`/profile/${profileID}`)
          setSending(false)
        } else {
          showAlert('Błąd w trakcie aktualizowania!', 'error')
        }

      } else {
        const url = profileId ? urls.addBoard(profileId) : urls.boards
        const response = await POST<board.BoardResponse>(url, {
          form: formData
        })
        if (response.ok) {
          const profileID = response.data?.data.id
          reload()
          setSending(false)
          showAlert('Dodano profil!', 'success')
          removeItem(true, PROFILE_STORAGE_KEY)
          if (showOrder && response.data.data.to_order) {
            openStore('qr_board', { related: response.data.data.to_order.params.related, profileName: response.data.data.name })

          } else {
            navigate(`/${profileId ? 'profile' : 'profilepin'}/${profileID}${profileId ? '' : `?modal=${isAuth ? 'info' : 'infoAndLogin'}`}`)
          }
        } else {
          showAlert('Błąd w trakcie dodawania!', 'error')
        }
      }

    } catch (err) {
      console.error(err)
    }
    setSending(false)
  }

  return {
    isSending,
    handleSubmit
  }
}

const generateFormData = (thereIsId: boolean, form: Form) => {
  const formData = new FormData()
  if (form.media.length > 0) {
    form.media.forEach((photo, index) => {
      formData.append(`media[${index}]`, photo)
    })
  }

  if (form.selectedImage) {
    formData.append('img', form.selectedImage)
  }

  if (form.sentence !== '') {
    formData.append('sentence', form.sentence)
  } else if (form.selectedOption) {
    formData.append('sentence', form.selectedOption.label)
  } else {
    formData.append('sentence', 'Spoczywaj w spokoju')
  }

  if (form.name || form.birth || form.death) {
    formData.append('name', form.name)
    formData.append('birth', form.birth)
    formData.append('death', form.death)
  }

  if (thereIsId) {
    formData.append('biography', parseSlateJSONToHTML(form.biography))
  }

  if (form.gps) {
    formData.append('gps[latitude]', form.gps.latitude.toString())
    formData.append('gps[longitude]', form.gps.longitude.toString())
  }
  return formData
}

export default useSending